import {
  Button,
  Card,
  Grid,
  InputItem,
  List,
  Modal,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import { ProductionTaskStatItemDTO } from "../schema";
import React, { useCallback, useEffect, useState } from "react";
import instance from "../../../util/axios";
import { Result } from "../../../schema";

export default function Stat(): JSX.Element {
  const [data, setData] = useState<ProductionTaskStatItemDTO[]>([]);
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    radId?: string;
    userId?: string;
    procedureId?: string;
    workshopId?: string;
    produceOrderId?: string;
    produceOrderDetailId?: string;
    bomDetailId?: string;
    count?: number;
    passCount?: string;
    backCount?: string;
  }>({
    visible: false,
  });

  const load = useCallback(() => {
    instance
      .get<Result<ProductionTaskStatItemDTO[]>>(
        `/erp/production-tasks/submitted`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setData(resp.data.Data);
        } else {
          Toast.fail(resp.data.Message);
        }
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      {data.map((item) => (
        <WingBlank size="lg">
          <WhiteSpace size="lg" />
          <Card>
            <Card.Header
              title={item.produceOrderSerialNumber}
              extra={
                <span>
                  {item.userName.indexOf(",") > -1
                    ? item.userName.split(",")[0] + "等"
                    : item.userName}
                </span>
              }
            />
            <Card.Body>
              <Grid
                square={false}
                hasLine={false}
                data={[
                  {
                    text: item.formulaName,
                  },
                  {
                    text: item.model,
                  },
                  {
                    text: item.colorName,
                  },
                  {
                    text: item.caliberName,
                  },
                  {
                    text: item.procedureName,
                  },
                  {
                    text: "数量：" + item.count,
                  },
                  {
                    text: item.bomDetailId ? "物料：" + item.skuName : "",
                  },
                ]}
                columnNum={2}
              />
            </Card.Body>
            <Card.Footer
              content={
                <>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <Button
                          icon="check-circle-o"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSubmitForm({
                              visible: true,
                              radId: item.radId,
                              userId: item.userId,
                              procedureId: item.procedureId,
                              workshopId: item.workshopId,
                              produceOrderId: item.produceOrderId,
                              produceOrderDetailId: item.produceOrderDetailId,
                              bomDetailId: item.bomDetailId || "",
                              count: item.count,
                              passCount: item.count + "",
                              backCount: "0",
                            });
                          }}
                        >
                          确认
                        </Button>
                      </td>
                    </tr>
                  </table>
                </>
              }
            />
          </Card>
          <WhiteSpace size="lg" />
        </WingBlank>
      ))}
      <Modal
        title={"确认数量"}
        visible={submitForm.visible}
        onClose={() =>
          setSubmitForm({
            visible: false,
          })
        }
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "确定",
            onPress: async () => {
              if (!submitForm.passCount) {
                Toast.fail(`通过数量有误`);
                return;
              }
              if (!submitForm.backCount) {
                Toast.fail(`打回数量有误`);
                return;
              }
              let totalCount = parseInt(submitForm.backCount);
              if (submitForm.passCount) {
                totalCount += parseInt(submitForm.passCount);
              }
              if (submitForm.count != totalCount) {
                Toast.fail(`通过数量和打回数量之和有误`);
                return;
              }
              const resp = await instance.post<Result<string>>(
                `/erp/production-tasks/confirm`,
                {
                  radId: submitForm.radId,
                  userId: submitForm.userId,
                  procedureId: submitForm.procedureId,
                  workshopId: submitForm.workshopId,
                  orderId: submitForm.produceOrderId,
                  orderDetailId: submitForm.produceOrderDetailId,
                  passCount: submitForm.passCount,
                  backCount: submitForm.backCount,
                }
              );
              if (resp.data.Status === "1") {
                Toast.success(`操作成功！`);
              } else {
                Toast.fail(resp.data.Data);
              }
              setSubmitForm({
                visible: false,
              });
              load();
            },
          },
        ]}
      >
        <List>
          <InputItem
            min={0}
            type={"digit"}
            value={submitForm.passCount}
            onChange={(value) =>
              setSubmitForm((prevState) => ({
                ...prevState,
                passCount: value,
              }))
            }
          >
            通过数量:
          </InputItem>
        </List>
        <List>
          <InputItem
            min={0}
            type={"digit"}
            value={submitForm.backCount}
            onChange={(value) =>
              setSubmitForm((prevState) => ({
                ...prevState,
                backCount: value,
              }))
            }
          >
            打回数量:
          </InputItem>
        </List>
      </Modal>
    </>
  );
}
